import { createBrowserRouter } from "react-router";
import { AdminLayout } from "../admin/AdminLayout";
import { AdminLoginPage } from "../admin/pages/AdminLoginPage";
import { AdminDashboard } from "../admin/pages/AdminDashboard";
import { AdminEventsPage } from "../admin/pages/AdminEventsPage";
import { AdminEventDetailPage } from "../admin/pages/AdminEventDetailPage";
import { AdminExhibitorsPage } from "../admin/pages/AdminExhibitorsPage";
import { AdminAccessPage } from "../admin/pages/AdminAccessPage";
import { AdminExhibitorDetailPage } from "../admin/pages/AdminExhibitorDetailPage";
import { AdminCompanyLeadsPage } from "../admin/pages/AdminCompanyLeadsPage";
import { AdminCompanyLeadDetailPage } from "../admin/pages/AdminCompanyLeadDetailPage";
import { AdminMapPage } from "../admin/pages/AdminMapPage";
import { AdminStatsPage } from "../admin/pages/AdminStatsPage";
import { AdminSchedulePage } from "../admin/pages/AdminSchedulePage";
import { AdminSupportLinksPage } from "../admin/pages/AdminSupportLinksPage";
import { AdminSupportInboxPage } from "../admin/pages/AdminSupportInboxPage";
import { AdminSupportBotGlobalPage } from "../admin/pages/AdminSupportBotGlobalPage";
import { AdminSupportBotEventPage } from "../admin/pages/AdminSupportBotEventPage";
import { AdminEventGroupsPage } from "../admin/pages/AdminEventGroupsPage";
import { AdminUiStringsPage } from "../admin/pages/AdminUiStringsPage";
import { AdminSettingsPage } from "../admin/pages/AdminSettingsPage";
import { ExhibitorDashboard as PortalExhibitorDashboard } from "../admin/pages/exhibitor/ExhibitorDashboard";
import { ExhibitorCompanyPage } from "../admin/pages/exhibitor/ExhibitorCompanyPage";
import { ExhibitorRepsPage } from "../admin/pages/exhibitor/ExhibitorRepsPage";
import { ExhibitorQRPage } from "../admin/pages/exhibitor/ExhibitorQRPage";
import { ExhibitorProductsPage } from "../admin/pages/exhibitor/ExhibitorProductsPage";
import { ExhibitorServicesPage } from "../admin/pages/exhibitor/ExhibitorServicesPage";
import { ExhibitorLeadsPage as AdminExhibitorLeadsPage } from "../admin/pages/exhibitor/ExhibitorLeadsPage";
import { ExhibitorLeadDetailPage } from "../admin/pages/exhibitor/ExhibitorLeadDetailPage";
import { ExhibitorYouScannedPage } from "../admin/pages/exhibitor/ExhibitorYouScannedPage";
import { ExhibitorYouScannedDetailPage } from "../admin/pages/exhibitor/ExhibitorYouScannedDetailPage";
import { ExhibitorAnalyticsPage } from "../admin/pages/exhibitor/ExhibitorAnalyticsPage";
import { ExhibitorDocumentsPage } from "../admin/pages/exhibitor/ExhibitorDocumentsPage";
import { CuratorAccreditationPage } from "../admin/pages/curator/CuratorAccreditationPage";
import { AdminQrGoRedirect } from "../admin/pages/AdminQrGoRedirect";
import { ADMIN_BASENAME } from "../admin/paths";

/** Staff portal: admins, curators, exhibitor back-office. Separate deploy / URL. */
export const adminRouter = createBrowserRouter(
  [
  {
    path: "/go/*",
    Component: AdminQrGoRedirect,
  },
  {
    path: "/",
    Component: AdminLayout,
    children: [
      { path: "login", Component: AdminLoginPage },
      { index: true, Component: AdminDashboard },
      { path: "events", Component: AdminEventsPage },
      { path: "support", Component: AdminSupportInboxPage },
      { path: "support-bot", Component: AdminSupportBotGlobalPage },
      { path: "event-groups", Component: AdminEventGroupsPage },
      { path: "ui-strings", Component: AdminUiStringsPage },
      { path: "settings", Component: AdminSettingsPage },
      { path: "events/:id", Component: AdminEventDetailPage },
      { path: "events/:id/exhibitors", Component: AdminExhibitorsPage },
      { path: "events/:id/access", Component: AdminAccessPage },
      { path: "events/:id/exhibitors/:companyId/leads", Component: AdminCompanyLeadsPage },
      { path: "events/:id/exhibitors/:companyId/leads/:leadId", Component: AdminCompanyLeadDetailPage },
      { path: "events/:id/exhibitors/:companyId/you-scanned", Component: AdminCompanyLeadsPage },
      {
        path: "events/:id/exhibitors/:companyId/you-scanned/:leadId",
        Component: AdminCompanyLeadDetailPage,
      },
      { path: "events/:id/exhibitors/:companyId", Component: AdminExhibitorDetailPage },
      { path: "events/:id/map", Component: AdminMapPage },
      { path: "events/:id/stats", Component: AdminStatsPage },
      { path: "events/:id/schedule", Component: AdminSchedulePage },
      { path: "events/:id/support", Component: AdminSupportLinksPage },
      { path: "events/:id/support-bot", Component: AdminSupportBotEventPage },
      { path: "events/:id/accreditation", Component: CuratorAccreditationPage },
      { path: "exhibitor", Component: PortalExhibitorDashboard },
      { path: "exhibitor/company", Component: ExhibitorCompanyPage },
      { path: "exhibitor/reps", Component: ExhibitorRepsPage },
      { path: "exhibitor/qr", Component: ExhibitorQRPage },
      { path: "exhibitor/products", Component: ExhibitorProductsPage },
      { path: "exhibitor/services", Component: ExhibitorServicesPage },
      { path: "exhibitor/leads", Component: AdminExhibitorLeadsPage },
      { path: "exhibitor/leads/:id", Component: ExhibitorLeadDetailPage },
      { path: "exhibitor/you-scanned", Component: ExhibitorYouScannedPage },
      { path: "exhibitor/you-scanned/:id", Component: ExhibitorYouScannedDetailPage },
      { path: "exhibitor/analytics", Component: ExhibitorAnalyticsPage },
      { path: "exhibitor/documents", Component: ExhibitorDocumentsPage },
    ],
  },
  ],
  { basename: ADMIN_BASENAME === "/" ? undefined : ADMIN_BASENAME },
);
